// import Service from '@/service/index.js';
import UploadImage from '@/components/upload-image/index.vue';
import PurchaseBusinessService from '../../purchase-business-service.js';

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      id: '',
      detail: {},
      form: {
        purchaseId: '',
        files: [{
          urls: [],
          imgEnumType: 5
        }]
      },
      // action: '/api/v1.0/chanquan/fast/uploadFile',
      filedata: {},
      filedatasuccess: false
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.form.purchaseId = this.$route.query.id;
    PurchaseBusinessService.getPurchaseConfirmLetter(this.id).then(res => {
      if (res && res.code === '0' && res.data){
        this.detail = res && res.data.letterResForm;
      }
    });
  },
  methods: {
    previousStep () {
      this.$router.back();
    },
    submit() {
      // if(this.filedatasuccess === false){
      //   this.$message({
      //     message: '请上传响应（投标）文件',
      //     type: 'warning',
      //     duration: 1000,
      //     offset: 327
      //   });
      // }else
      this.$confirm('确定确认成交书？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PurchaseBusinessService.confirmDealBook(this.form).then(res => {
          if(res.code === '0'){
            this.$message({
              message: '确认成功',
              type: 'success',
              duration: 1000,
              offset: 327
            });
            this.$router.back();
          } else {
            this.$errorMessage(res.reason);
          }
        });
      }).catch(() => {});
    },
    // 文件上传成功
    handleUpSuccess(response, file, fileList) {
      this.filedata = fileList[0].response.data;
      this.form.files[0].urls[0] = this.filedata.fullPath;
      this.filedatasuccess = true;
    },
    handleUpRemove() {
      this.filedata = {};
      this.filedatasuccess = false;
    },
    beforeUpload(file) {
      var testmsg=file.name.substring(file.name.lastIndexOf('.')+1);
      const extension = testmsg === 'xls';
      const extension2 = testmsg === 'xlsx';
      const extension3 = testmsg === 'doc';
      const extension4 = testmsg === 'docx';
      const extension5 = testmsg === 'pdf';
      const isLt2M = file.size / 1024 / 1024;
      if(!extension && !extension2 && !extension3 && !extension4 && !extension5) {
        this.$message({
          message: '上传文件只能是 doc、docx、pdf、xls、xlsx格式!',
          type: 'error',
          duration: 1000,
          offset: 327
        });
      }
      if(isLt2M > 50) {
        this.$message({
          message: '上传文件大小不能超过 50MB!',
          type: 'error',
          duration: 1000,
          offset: 327
        });
      }
      return (extension || extension2 || extension3 || extension4 || extension5) && isLt2M;
    }
  }
};
